import { useQuery } from '@tanstack/react-query';
import { container } from '@intigral/domain/lib/DataDomain';
import { IUserRegistrationService } from '@intigral/domain/lib/application/services/UserRegistrationService';
import { DI } from '@intigral/constant/config/DIContainer';
import { getCountry } from '../helpers/common';
import { useDispatch, useSelector } from 'react-redux';
import { IStore } from '../interfaces/StoreTypes';
import { updatePPVCountryConfig } from '../store/reducers/generalConfigurationSlice';
import { useConfigurationSections } from './useConfiguration';

export default function usePPVConfig() {
    // Using React Query instead of Redux for configuration
    const { config } = useConfigurationSections();
    const { countryCodeThreeLettersMapping = null } = (config as any) || {};
    const dispatch = useDispatch();

    const query = useQuery({
        queryKey: ['ppv_country_config'],
        queryFn: async () => {
            try {
                const countryCode = getCountry();
                const threeLetterCountryCode = countryCodeThreeLettersMapping?.[countryCode];
                const commonService = container.resolve<IUserRegistrationService>(DI.SERVICES.IUserRegistrationService);
                const response = await commonService.getPPVCountryConfig(threeLetterCountryCode);
                const data = response?.countries || [];
                dispatch(updatePPVCountryConfig(data));
                return data;
            } catch (e) {
                return [];
            }
        },
        staleTime: 15 * 60 * 1000,
    });

    return {
        ...query,
        refetchPPVConfig: query.refetch,
    };
}
